import { Bell, Menu, Search, Plus, Users, UserCog, Moon, Sun, Settings2 } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

export const TopBar = ({
  searchQuery,
  onSearch,
  onAddCompany,
  onAddBusiness,
  onAddProject,
  onAddTeamMember,
  onOpenNotifications,
  onOpenUsers,
  onAddOpsSite,
  onToggleSidebar,
  hasCompanies,
  hasBusinesses,
  notificationCount = 0,
  canManageUsers = false,
  canManageTeam = false,
  canEdit = false,
  onToggleTheme,
  theme = "light",
}) => (
  <header className="topbar" data-testid="topbar">
    <div className="topbar-search">
      <button className="mobile-nav-toggle" onClick={onToggleSidebar} type="button">
        <Menu size={18} />
      </button>
      <div className="relative flex-1">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
        <Input
          type="text"
          placeholder="Search everything..."
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          className="pl-10 bg-zinc-50 border-zinc-200 focus:border-zinc-900 rounded-none text-sm"
        />
      </div>
    </div>
    <div className="topbar-actions">
      <Button aria-label={`Use ${theme === "dark" ? "light" : "dark"} mode`} className="topbar-icon-button rounded-none border-zinc-300" onClick={onToggleTheme} title={`Use ${theme === "dark" ? "light" : "dark"} mode`} type="button" variant="outline">
        {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
      </Button>
      <Button aria-label="Open alerts" className="topbar-icon-button rounded-none border-zinc-300 relative" onClick={onOpenNotifications} title="Alerts" type="button" variant="outline">
        <Bell size={16} />
        {notificationCount ? <span className="topbar-alert-count">{notificationCount > 99 ? "99+" : notificationCount}</span> : null}
      </Button>
      {(canManageTeam || canManageUsers) ? <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className="topbar-action-button rounded-none border-zinc-300" type="button" variant="outline">
            <Settings2 size={14} className="mr-2" /> Manage
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          {canManageTeam ? <DropdownMenuItem onClick={onAddTeamMember}><Users size={14} className="mr-2" /><span className="font-medium">Team</span></DropdownMenuItem> : null}
          {canManageUsers ? <DropdownMenuItem onClick={onOpenUsers}><UserCog size={14} className="mr-2" /><span className="font-medium">Users</span></DropdownMenuItem> : null}
        </DropdownMenuContent>
      </DropdownMenu> : null}
      {canEdit ? <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className="topbar-primary-action bg-zinc-900 text-white hover:bg-zinc-800 rounded-none px-4 py-2 text-xs font-bold uppercase tracking-wider">
            <Plus size={14} className="mr-2" /> Add New
          </Button>
        </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuItem onClick={onAddCompany}><span className="font-medium">Company</span></DropdownMenuItem>
            <DropdownMenuItem onClick={onAddBusiness} disabled={!hasCompanies}><span className={!hasCompanies ? "text-zinc-400" : "font-medium"}>Business</span></DropdownMenuItem>
            <DropdownMenuItem onClick={onAddProject} disabled={!hasBusinesses}><span className={!hasBusinesses ? "text-zinc-400" : "font-medium"}>Project</span></DropdownMenuItem>
            <DropdownMenuItem onClick={onAddOpsSite} disabled={!hasBusinesses}><span className={!hasBusinesses ? "text-zinc-400" : "font-medium"}>Operations Site</span></DropdownMenuItem>
            {canManageTeam ? <DropdownMenuItem onClick={onAddTeamMember}><span className="font-medium">Team Member</span></DropdownMenuItem> : null}
          </DropdownMenuContent>
      </DropdownMenu> : null}
    </div>
  </header>
);
